
declare var dataLayer: any;
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {
    PasswordInput: () => import("./PasswordInput.vue"),
    ForgotPass: () => import("@/components/Jobs/Common/ForgotPass.vue"),
  },
})
export default class Login extends Vue {
  @Prop(Boolean) openLogin!: boolean;
  email_form = "";
  password_form = "";
  error = null;
  forgotPass = false;
  hash = Math.random() * 100000;

  mounted() {
    if ((this as any).$route.params.token) (this as any).forgotPass = true;
  }

  @Watch("openLogin")
  onChangeIsUniSearch(val: string) {
    if (val && !status) {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/iniciar-sesion",
        virtualPageTitle: "Iniciar Sesión",
      });
    }
    if (!status) {
      this.forgotPass = false;
    } else {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/recuperar-contrasena",
        virtualPageTitle: "Recuperar Contraseña",
      });
    }
  }

  onPasswordChange(value: any, type: any) {
    (this as any).password_form = value.target.value;
  }

  destroyed() {
    this.forgotPass = false;
  }

  hide() {
    this.forgotPass = false;
  }

  async submitForm() {
    try {
      var response = await (this.$root as any)._post("user/login", {
        username: (this as any).email_form,
        password: (this as any).password_form,
        sendactivate: true,
      });

      if (!response.user.active)
        throw {
          message:
            "El usuario no ha sido activado aún. Te hemos enviado nuevamente el correo con las instrucciones para activar la cuenta.",
        };

      this.$store.commit("setToken", response.token);
      const id = response.user.id;

      response = await (this.$root as any)._get(
        "user/one/?includes=users_experiences,users_educations,users_professionals,users_languages,offers"
      );
      dataLayer.push({
        event: "Event",
        category: "engagement",
        action: "login",
        label: "Mail",
      });
      this.$store.commit("setUser", response.data[0]);
      let quick_offer = localStorage.getItem("bayton-quick-offer");
      if (quick_offer) {
        localStorage.removeItem("bayton-quick-offer");
        (window as any).location = `/ofertas/${quick_offer}?quick=1`;
      } else {
        window.location.reload();
      }
    } catch (e) {
      this.error = e.message;

      setTimeout(() => {
        this.error = null;
      }, 5000);
    }
  }
}
